<form [formGroup]="delegationFormGroup"></form>

<app-worker-delegation-list [workerId]="workerId"></app-worker-delegation-list>
